import { toast } from 'sonner';

import { useApiMutation, useTableDataQuery } from '@/modules/common';

import {
  CreateProductSetPayload,
  EventQueryKeys,
  ProductSet,
  ProductSetConflict,
  ProductSetConflictsPayload,
} from '../types';

export function useEventProductSets(
  eventId: string,
  stationId: string,
  enabled = true
) {
  const baseUrl = `/events/${eventId}/stations/${stationId}/product-sets`;

  const {
    data: productSets,
    isFetching,
    ...restTableProps
  } = useTableDataQuery<ProductSet>({
    url: baseUrl,
    baseQueryKey: [EventQueryKeys.ProductSets, eventId, stationId],
    // @ts-ignore
    queryOptions: {
      enabled: !!eventId && !!stationId && enabled,
    },
  });

  const createProductSetMutation = useApiMutation<
    CreateProductSetPayload,
    ProductSet
  >(
    baseUrl,
    {
      method: 'POST',
    },
    {
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );

  // Advisory only: reports which product/size pairs already sit in another set
  // of the same station. Errors are handled by the caller so a failed check
  // never blocks saving.
  const checkConflictsMutation = useApiMutation<
    ProductSetConflictsPayload,
    ProductSetConflict[]
  >(`${baseUrl}/conflicts`, {
    method: 'POST',
  });

  return {
    productSets,
    isFetching,
    restTableProps,
    createProductSetMutation,
    checkConflictsMutation,
  } as const;
}
